<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东进公司开展消防技能培训活动及溴甲烷中毒应急演练</h2>
        <p>
          为进一步普及安全知识，营造良好安全氛围，提高全员安全意识和应急处置能力，2023年11月14日，广东东进有害生物防控技术有限公司（以下简称“东进公司”）开展主题为“预防为主，生命至上”的消防技能培训活动及溴甲烷中毒应急演练。东进公司总经理王伟，综合管理部总监张雪婷和品质运营部总监肖彪到场观摩指导。
        </p>
        <img
          width="100%"
          :src="img[0]"
          alt=""
        >
        <!-- <h3>消防技能培训活动</h3> -->
        <section
          style="text-align: center;margin-top: 10px;margin-bottom: 10px;line-height: 0;"
          powered-by="xiumi.us"
        >
          <section
            style="vertical-align: middle;display: inline-block;line-height: 0;"
          ><img
              class="rich_pages wxw-img"
              data-ratio="0.75"
              data-s="300,640"
              data-src="https://mmbiz.qpic.cn/sz_mmbiz_jpg/rHl1V3ANp5171PklJhbB8VTjIHUAhRnq3Dt9ic98NRVReicfKM6B4E2maA2ib86qbaicOYAiarGYaFo1ibsZUiagCM4icg/640?wx_fmt=jpeg"
              data-type="jpeg"
              data-w="1080"
              style="vertical-align: middle;width: 100%;"
            ></section>
        </section>
        <section
          style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row nowrap;margin-top: 10px;margin-bottom: 4px;"
          powered-by="xiumi.us"
        >
          <section
            style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;height: auto;border-style: solid;border-width: 3px 0px 0px;border-color: rgb(69, 107, 176);padding-top: 4px;"
          >
            <section
              style="justify-content: flex-start;display: flex;flex-flow: row nowrap;"
              powered-by="xiumi.us"
            >
              <section
                style="display: inline-block;width: auto;align-self: flex-start;flex: 0 0 auto;background-color: rgb(69, 107, 176);padding: 7px 20px;"
              >
                <section
                  style="text-align: justify;color: rgb(255, 255, 255);"
                  powered-by="xiumi.us"
                >
                  <p
                    class="wenzi"
                    style="white-space: normal; text-indent: 0;"
                  >消防技能培训活动</p>
                </section>
              </section>
            </section>
          </section>
        </section>
        <section
          style="margin-bottom: 8px;"
          powered-by="xiumi.us"
        >
          <section style="background-color: rgb(69, 107, 176);height: 3px;"><svg
              viewbox="0 0 1 1"
              style="float:left;line-height:0;width:0;vertical-align:top;"
            ></svg></section>
        </section>
        <p>
          为了提高我公司员工的消防安全意识，加强消防安全知识的普及，增强员工在火灾突发状况下的自防自救能力，东进公司开展消防技能培训活动。活动分为两个部分：消防知识讲解和实操演练。
        </p>
        <p>
          消防知识重点讲解了火灾的成因及预防措施、火灾报警与应急疏散流程、灭火器的种类和使用方法、员工消防安全职责。加强了员工的理论知识，提高了员工的消防安全意识。
        </p>

        <p>灭火器实操演练，要将所学知识运用到实际工作中，提升自防自救的能力，共同为公司的安全生产贡献力量。</p>

        <p>
          本次演练通过场景模拟的方式处置火情，演练过程中，指挥人员对消防知识进行详细地讲解并演示正确的灭火器使用方法，整个演练过程规范到位。通过这次消防技能培训活动，员工们掌握了正确的灭火器处理方法和步骤，积累了事故处理的实践经验，提高了安全风险防范意识和能力。
        </p>
        <img
          width="100%"
          :src="img[1]"
          alt=""
        >
        <section
          style="text-align: center;margin-top: 10px;margin-bottom: 10px;line-height: 0;"
          powered-by="xiumi.us"
        >
          <section
            style="vertical-align: middle;display: inline-block;line-height: 0;"
          ><img
              class="rich_pages wxw-img"
              data-ratio="0.75"
              data-s="300,640"
              data-src="https://mmbiz.qpic.cn/sz_mmbiz_jpg/rHl1V3ANp5171PklJhbB8VTjIHUAhRnq3Dt9ic98NRVReicfKM6B4E2maA2ib86qbaicOYAiarGYaFo1ibsZUiagCM4icg/640?wx_fmt=jpeg"
              data-type="jpeg"
              data-w="1080"
              style="vertical-align: middle;width: 100%;"
            ></section>
        </section>
        <section
          style="text-align: left;justify-content: flex-start;display: flex;flex-flow: row nowrap;margin-top: 10px;margin-bottom: 4px;"
          powered-by="xiumi.us"
        >
          <section
            style="display: inline-block;width: auto;vertical-align: top;align-self: flex-start;flex: 0 0 auto;min-width: 5%;height: auto;border-style: solid;border-width: 3px 0px 0px;border-color: rgb(69, 107, 176);padding-top: 4px;"
          >
            <section
              style="justify-content: flex-start;display: flex;flex-flow: row nowrap;"
              powered-by="xiumi.us"
            >
              <section
                style="display: inline-block;width: auto;align-self: flex-start;flex: 0 0 auto;background-color: rgb(69, 107, 176);padding: 7px 20px;"
              >
                <section
                  style="text-align: justify;color: rgb(255, 255, 255);"
                  powered-by="xiumi.us"
                >
                  <p
                    class="wenzi"
                    style="white-space: normal; text-indent: 0;"
                  >溴甲烷中毒应急演练</p>
                </section>
              </section>
            </section>
          </section>
        </section>
        <section
          style="margin-bottom: 8px;"
          powered-by="xiumi.us"
        >
          <section style="background-color: rgb(69, 107, 176);height: 3px;"><svg
              viewbox="0 0 1 1"
              style="float:left;line-height:0;width:0;vertical-align:top;"
            ></svg></section>
        </section>
        <p>
          当日东进公司还开展了溴甲烷中毒应急演练，本次演练模拟人员吸入溴甲烷导致的中毒事故场景，旨在检验港口服务部的应急响应能力，提高安全防范意识。
        </p>

        <p>
          为确保演习的真实性和有效性,港口服务部对应急预案进行了精心策划和准备，针对演练方案进行了预演练，及时找出方案和人员在操作中的问题并加以修正，使演练时尽可能接近事故发生时的真实场景，达到应急演练的目的。
        </p>

        <p>
          在演习过程中,参演人员重点对人员中毒施救、危险化学品泄漏处理、个人防护用品使用等环节进行演练，以检验应急预案的可行性、实效性以及人员的应急响应处置能力。
        </p>
        <img
          width="100%"
          :src="img[2]"
          alt=""
        >
        <p>
          本次消防技能培训活动和溴甲烷中毒应急演练为公司员工提供了一次实战模拟训练，使员工熟悉必需的应急操作，进一步增强了员工安全防范意识和应急能力，为真正的事故应急行动提供了宝贵的经验，检验了应急预案的可行性、可操作性，对应急指挥、协调和处理能力起到有力的促进作用，对今后高效、有序地开展应急工作奠定了坚实的基础。
        </p>
        <h3>我们还提供多元化服务</h3><img
          width="100%"
          :src="img[3]"
          alt=""
        >
        <!-- <h3>扫码关注我们了解更多</h3>
        <div class="big-div">
          <div class="small-div1">
            <img :src="img[4]" alt="">
            <div class="caption">时代东进 砥砺奋进</div>
          </div>
          <div class="small-div2">
            <img :src="img[5]" alt="">
            <div class="caption">www.tonking.com.cn <br>0769-22008298</div>
          </div>
        </div> -->
        <div>
          <img
            :src="img[6]"
            alt=""
          >
        </div>

      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News9'})"
          >东进公司参加南城街道校园...&nbsp;&nbsp;&nbsp;&nbsp;上一条 &gt;
          </span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News7'})"
          >东进公司参加...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;
          </span>
        </el-col>

      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news8-1.png'), require('@/assets/news8-2.png'), require('@/assets/news8-3.png'), require('@/assets/news8-4.png'), require('@/assets/news8-5.png'), require('@/assets/news8-6.png'), require('@/assets/news8-7.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}
.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}
@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>
